/** Screen wake lock. Auto-released whenever the page hides, so it must be
 *  re-acquired on every return to visible. Broken in installed iOS home-screen
 *  apps before 18.4 — callers surface an instruction to disable auto-lock instead. */
export class WakeLock {
  private sentinel: WakeLockSentinel | null = null;

  get supported(): boolean {
    return "wakeLock" in navigator;
  }

  get held(): boolean {
    return this.sentinel !== null && !this.sentinel.released;
  }

  async acquire(): Promise<boolean> {
    if (!this.supported) return false;
    if (this.held) return true;
    try {
      this.sentinel = await navigator.wakeLock.request("screen");
      this.sentinel.addEventListener("release", () => { this.sentinel = null; });
      return true;
    } catch {
      return false; // Denied, or iOS < 18.4 in an installed web app.
    }
  }

  async release(): Promise<void> {
    try { await this.sentinel?.release(); } catch { /* already gone */ }
    this.sentinel = null;
  }
}
